<template>
  <div>
    <Head :title="`Preview: ${announcement.title}`" />

    <div class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          @click="close" />

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen">
          &#8203;
        </span>

        <div
          class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="text-2xl leading-6 font-bold text-gray-900">
                    {{ announcement.title }}
                  </h3>
                  <button
                    @click="close"
                    class="text-gray-400 hover:text-gray-500 focus:outline-none">
                    <svg
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div class="mb-4 flex space-x-2">
                  <span
                    class="px-2 py-1 text-xs font-semibold rounded-full"
                    :class="{
                      'bg-green-100 text-green-800': announcement.portal_status === 'open',
                      'bg-red-100 text-red-800': announcement.portal_status === 'closed',
                    }">
                    {{ announcement.portal_status === 'open' ? 'Portal Open' : 'Portal Closed' }}
                  </span>

                  <span
                    v-if="announcement.is_active"
                    class="px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                    Aktif
                  </span>
                  <span
                    v-else
                    class="px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
                    Tidak Aktif
                  </span>
                </div>

                <div
                  class="prose max-w-none"
                  :class="{
                    'prose-green': announcement.portal_status === 'open',
                    'prose-red': announcement.portal_status === 'closed',
                  }"
                  v-html="announcement.content" />

                <div
                  v-if="announcement.scheduled_open_at || announcement.scheduled_close_at"
                  class="mt-6 pt-4 border-t">
                  <div v-if="announcement.scheduled_open_at" class="text-sm text-gray-600">
                    <strong>Jadwal Buka:</strong>
                    {{ formatDate(announcement.scheduled_open_at) }}
                  </div>
                  <div v-if="announcement.scheduled_close_at" class="text-sm text-gray-600">
                    <strong>Jadwal Tutup:</strong>
                    {{ formatDate(announcement.scheduled_close_at) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              @click="close"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue2'

export default {
  components: {
    Head,
  },

  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },

  methods: {
    close () {
      window.close()
    },

    formatDate (date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('id-ID', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
}
</script>

<style scoped>
.prose {
  @apply text-gray-700;
}

.prose-green {
  @apply bg-green-50;
}

.prose-red {
  @apply bg-red-50;
}

.prose >>> h1 {
  @apply text-2xl font-bold mb-4;
}

.prose >>> h2 {
  @apply text-xl font-bold mb-3;
}

.prose >>> h3 {
  @apply text-lg font-bold mb-2;
}

.prose >>> p {
  @apply mb-3;
}

.prose >>> ul {
  @apply list-disc pl-5 mb-3 space-y-1;
}

.prose >>> ol {
  @apply list-decimal pl-5 mb-3 space-y-1;
}

.prose >>> ul li,
.prose >>> ol li {
  @apply mb-1;
}

.prose >>> ul li::marker {
  color: #6b7280;
}

.prose >>> ol li::marker {
  color: #6b7280;
}

.prose >>> a {
  @apply text-indigo-600 underline;
}

.prose >>> strong {
  @apply font-bold;
}
</style>
